<template>
   <van-tab title="活动亮点">
      <img class="one-img" src="../../../../assets/images/home/highlights_02.png" alt="">
    </van-tab>
</template>
<script>
export default {
  data() {
    return {
    }
  }
}
</script>
